var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBtnTukarUangUsaha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 4.83333L14.167 4.83333M14.167 4.83333L10.8337 1.5M14.167 4.83333L10.8337 8.16667M10.8337 13.1667L0.83366 13.1667M0.83366 13.1667L4.16699 16.5M0.83366 13.1667L4.16699 9.83333",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnTukarUangUsaha);
export default __webpack_public_path__ + "static/media/ic-btn-tukar-uang-usaha.187e52e54263002436f6b3a1fbc2aa87.svg";
export { ForwardRef as ReactComponent };